export default {
  tabs: {
    multiCurrency: "多币种画布",
    singleCurrency: "单币种画布",
    solana: "solana画布",
  },
  buttons: {
    createCanvas: "新建画布",
  },
  search: {
    canvasName: "请输入画布名称",
    startDate: "开始日期",
    endDate: "结束日期",
    reset: "重置",
    query: "查询",
    allCanvas: "所有画布",
    updateTime: "更新时间",
  },
  sort: {
    createTimeDesc: "创建时间降序",
    createTimeAsc: "创建时间升序",
    updateTimeDesc: "更新时间降序",
    updateTimeAsc: "更新时间升序",
  },
  table: {
    total: "共计",
    dataCount: "条数据",
    emptyText: "暂无数据",
    columns: {
      index: "序号",
      canvasName: "画布名称",
      canvasDescription: "画布描述",
      canvasType: "画布类型",
      addressHash: "地址/哈希",
      currency: "币种",
      chain: "链",
      creator: "创建人",
      createTime: "创建时间",
      updateTime: "更新时间",
      actions: "操作",
    },
    actions: {
      edit: "修改",
      keySteps: "关键步骤",
      delete: "删除",
    },
  },
  messages: {
    deleteConfirm: "此操作将永久删除该画布, 是否确定?",
    deleteTitle: "删除确认",
    deleteSuccess: "删除成功",
    deleteCancelled: "已取消删除",
    confirmButton: "确定",
    cancelButton: "取消",
  },
};
